import React, { useState } from "react";
import { RiUserSettingsLine, RiShieldKeyholeLine } from "react-icons/ri";
import SectionNavigation from "../../../Utility/SectionNavigation";
import RoleTab from "./RoleTab";
import PermissionTab from "./PermissionTab";

const RolePermission = () => {
  const [activeTab, setActiveTab] = useState("role");
  const [selectedRoleForPermission, setSelectedRoleForPermission] = useState(null);

  const navItems = [
    {
      id: "role",
      label: "Role",
      icon: RiUserSettingsLine,
    },
    {
      id: "permission",
      label: "Permission",
      icon: RiShieldKeyholeLine,
    },
  ];

  // Handle view role - switch to permission tab with selected role
  const handleViewRolePermissions = (role) => {
    setSelectedRoleForPermission(role.name);
    setActiveTab("permission");
  };

  // Handle tab change
  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    // Clear selected role when manually switching tabs
    if (tabId === "role") {
      setSelectedRoleForPermission(null);
    }
  };

  return (
    <div className="w-full">
      {/* Header */}

      {/* Tabs Navigation */}
      <SectionNavigation
        items={navItems}
        activeTab={activeTab}
        onTabChange={handleTabChange}
        iconSize={16}
      />

      {/* Tab Content */}
      {activeTab === "role" && <RoleTab onViewRolePermissions={handleViewRolePermissions} />}
      {activeTab === "permission" && (
        <PermissionTab initialSelectedRole={selectedRoleForPermission} />
      )}
    </div>
  );
};

export default RolePermission;
